import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import BottomDrawer from '../Drawer/Drawer';
import Button from '../Button/Button';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';
import { FullWidthButtonWrapper, ModalCloseIcon } from './Common';

const DrawerTitle = styled.span`
  font-family: ${variables.family.goldSilver};
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${themeColors.colorTextPrimary};
`;

const Subtitle = styled.p`
  display: block;
  font-family: ${variables.family.goldSilver};
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${themeColors.colorTextPrimary};
  margin: 0 0 ${pxToRem(12)};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: 14px;
  }
`;

const Body = styled.p`
  display: block;
  font-family: ${variables.family.goldSilver};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${themeColors.colorTextSecondary};
  margin: 0;
`;

const ActionButton = styled(FullWidthButtonWrapper)`
  margin-top: ${pxToRem(16)};

  button {
    width: 100%;
    font-family: ${variables.family.goldSilver};
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
  }
`;

const AlertInfoDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={<DrawerTitle>{t('gtt.alertIntro.title')}</DrawerTitle>}
      closeIcon={<ModalCloseIcon />}
    >
      <Subtitle>{t('gtt.alertIntro.subtitle')}</Subtitle>
      <Body>{t('gtt.alertIntro.paragraph')}</Body>
      <ActionButton>
        <Button
          variant="primaryOutlined"
          textTransform="none"
          type="button"
          onClick={onClose}
          data-cy="button-alert-info-lets-go"
        >
          {t('gtt.common.letsGo')}
        </Button>
      </ActionButton>
    </BottomDrawer>
  );
};

AlertInfoDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AlertInfoDrawer;
